import React from 'react';
import DivContainerBody from '../../../../../../../components/DivContainerBody';
import HeadTittle from '../../../../../../../components/HeadTittle';
import ButtonAction from '../../../../../../../components/buttons/ButtonAction';
import {AddIcon, EditIcon} from '../../../../../../../components/buttons/IconButtons';
import DividerWithText from '../../../../../../../components/DividerWithText';
import PolicyDetails from "../../Global/CreateUpdatePolicy/SubComponents/PolicyDetails";
import RuleForm from "../../Global/CreateUpdatePolicy/SubComponents/RuleForm";
import CommonPolicyApp from "../../Global/CreateUpdatePolicy/Functionality/CommonPolicyApp";
import RulesTable from "../../Global/CreateUpdatePolicy/SubComponents/RulesTable";
import DeleteModal from '../../../../../../Modals/DeleteModal';
import ClonePolicyGroupApp from "./Functionality/ClonePolicyGroupApp";


/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 */
const UpdatePolicyGroup = () => {
    const {
        t,
        navigate,
        isGlobal,
        item,
        setItem,
        handleChange,
        emptyFields,
        setEmptyFields,
        departments,
        setDepartments,
        handleReorderRules,
        goBack,
        rule,
        setRule,
        updateRuleField,
        ruleEmptyFields,
        setRuleEmptyFields,
        ruleIsValid,
        ruleIsValidCalculationValue,
        ruleIsValidCalculationValueText,
        handleAddRule,
        handleDeleteRule,
        confirmDeleteRule,
        showDeleteModal,
        setShowDeleteModal,
        selectedItem,
        setSelectedItem,
        isRuleFormValid
    } = CommonPolicyApp();

    const {
        handleClone,
    } = ClonePolicyGroupApp({
        t,
        item,
        setItem,
        rule,
        setRule,
        departments,
        setDepartments,
        navigate,
        isGlobal,
        setEmptyFields,
        goBack,
        setRuleEmptyFields
    });

    return (
        <>
            <HeadTittle onBack={goBack} name='clone'>
                <ButtonAction
                    id='btn_cpg_clone'
                    name='clone'
                    Icon={EditIcon}
                    className='btn-icon-edit'
                    onClick={handleClone}
                />
            </HeadTittle>
            <DivContainerBody>
                <div className={"mt-4 mb-60px"}>
                    <PolicyDetails
                        item={item}
                        setItem={setItem}
                        handleChange={handleChange}
                        emptyFields={emptyFields}
                        selectedList={departments}
                        setSelectedList={setDepartments}
                    />
                    <DividerWithText title={t('rule_conditions')} spacing={'my-4'} />
                    <RuleForm
                        rule={rule}
                        updateRuleField={updateRuleField}
                        emptyFields={ruleEmptyFields}
                        isGlobal={isGlobal}
                        isValid={ruleIsValid}
                        isValidCalculationValue={ruleIsValidCalculationValue}
                        isValidCalculationValueText={ruleIsValidCalculationValueText}
                    />
                    <div className='col-12 d-flex justify-content-end'>
                        <ButtonAction
                            id='btn_cpg_add_rule'
                            name='add_new_rule'
                            Icon={AddIcon}
                            className='btn-secondary-600'
                            onClick={handleAddRule}
                            splitName={false}
                            disabled={!isRuleFormValid()}
                        />
                    </div>
                    { item.rules?.length > 0 &&
                        <div className={"border-full-shades-300 border-radius-8px mt-4 p-3"}>
                            <RulesTable
                                rules={item.rules}
                                isGlobal={isGlobal}
                                sortable={true}
                                onDragEnd={handleReorderRules}
                                onDeleteRule={handleDeleteRule}
                            />
                        </div>
                    }
                </div>
            </DivContainerBody>
            <DeleteModal
                show={showDeleteModal}
                onHide={() => {
                    setShowDeleteModal(false);
                    setSelectedItem(null);
                }}
                onClickFn={confirmDeleteRule}
                title_modal="delete_rule"
                data={[selectedItem]}
                element_modal="rule"
            />
        </>
    );
};

export default UpdatePolicyGroup;
